module.exports = "https://www.gc-qa.gnp.com.mx/5d618ba8b1e6b1729a8c5378b66b1e19.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_rcEUA.svg
// module id = 8135
// module chunks = 0